import React, { Component } from "react";
import Pitch from "../components/Pitch";
import ReactMarkdown from "react-markdown";
import Formationquestions from "./Formationquestions.md";
// Images
import imgFormation from "../images/g-suite-formation.png";

class Formation extends Component {
  constructor() {
    super();
    this.state = { markdown: "" };
  }
  UNSAFE_componentWillMount() {
    // Get the contents from the Markdown file and put them in the React state, so we can reference it in render() below.
    fetch(Formationquestions)
      .then(res => res.text())
      .then(text => this.setState({ markdown: text }));
  }
  render() {
    const { markdown } = this.state;
    const title = "Formation à l'utilisation de G Suite ​​​​​​​et de ses applications";
    const text1 = `Prospection accompagne votre équipe dans la prise en main et la maîtrise des applications et l'utilisation des fonctionnalités de la solution G Suite. Nos experts vous apprendrons à maîtriser rapidement les applications G Suite`;
    const text2 = `En quelques heures, votre équipe utilisera votre G Suite avec aisance.`;
    const imgStyle = {
      display: "flex",
      alignSelf: "flex-end"
    };
    const textStyle = {
      paddingTop: "60px",
      paddingBottom: "60px"
    };

    return (
      <section className="formation">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 order-lg-1" style={textStyle}>
              <h2>{title}</h2>
              <Pitch>
                <ReactMarkdown source={markdown} />
              </Pitch>
              <p>{text1}</p>
              <p>{text2}</p>
            </div>
            <div className="col-lg-6 d-flex order-lg-0">
              <img
                style={imgStyle}
                className="img-fluid imgFormation"
                src={imgFormation}
                alt="Formation G Suite"
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Formation;
